import { NEXA_APPLICATION_URL } from "@/lib/constants";

// Where an Apply button should send someone.
// House pages (no MLO in context) use the Great Rate Check application.
// MLO pages use that MLO's own application link — and if it isn't set yet we
// return null so callers can offer a phone call instead of sending the
// borrower into someone else's pipeline.
export function resolveApplyUrl(mlo) {
  if (!mlo) return NEXA_APPLICATION_URL;
  return (mlo.apply_url || "").trim() || null;
}

// The branded apply page for this context.
export function applyPagePath(mlo) {
  return mlo?.slug ? `/${mlo.slug}/apply` : "/apply";
}

export function telHref(phone) {
  return phone ? `tel:${phone.replace(/[^+0-9]/g, "")}` : null;
}
